import React from "react";
import { Modal, Button } from "react-bootstrap";
import PropTypes from "prop-types";

const ConfirmDeleteModal = ({
  show,
  handleClose,
  handleConfirm,
  title = "Подтверждение удаления",
  body,
  partnerName = "этого партнёра",
  confirmLabel = "Удалить",
}) => {
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {body || (
          <>
            Вы уверены, что хотите удалить партнёра <strong>{partnerName}</strong>?
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Отмена
        </Button>
        <Button variant="danger" onClick={handleConfirm}>
          {confirmLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

ConfirmDeleteModal.propTypes = {
  show: PropTypes.bool.isRequired, // Булево значение (true/false)
  handleClose: PropTypes.func.isRequired, // Функция закрытия модального окна
  handleConfirm: PropTypes.func.isRequired, // Функция подтверждения удаления
  title: PropTypes.string,
  body: PropTypes.node,
  partnerName: PropTypes.string, // Имя партнера (строка)
  confirmLabel: PropTypes.string,
};

export default ConfirmDeleteModal;
